import React from "react";
import PolicyLayout, { Section, PolicyList } from "../../components/storefront/PolicyLayout";

export default function RefundPolicy() {
  return (
    <PolicyLayout
      testid="refund-policy-page"
      heading="Refund Policy"
      title="Refund Policy | Lecis Auto Glass"
      description="Lecis Auto Glass refund policy — refund timing, inspection process, non-refundable items and how shipping costs are treated."
      canonicalPath="/refund-policy"
      updated="June 2026"
    >
      <Section>
        <p>
          This Refund Policy explains how refunds are processed once an authorized return is received. Please
          also review our Return Policy for return eligibility and the authorization process.
        </p>
      </Section>

      <Section title="Inspection Process">
        <p>
          When your returned item arrives, our team inspects it to confirm it meets the condition requirements
          in our Return Policy (unused, uninstalled, resalable, with original packaging and components). Refunds
          are issued after this inspection is complete.
        </p>
      </Section>

      <Section title="Refund Timing">
        <PolicyList
          items={[
            "Once a return is inspected and approved, refunds are issued to your original payment method.",
            "Refunds are typically processed within 3–5 business days of approval.",
            "After we process the refund, your bank or card issuer may take additional business days to post the credit to your statement.",
            "Card payments are securely processed through Stripe; refunds are returned to the same card used at checkout.",
          ]}
        />
      </Section>

      <Section title="Shipping Cost Treatment">
        <PolicyList
          items={[
            "Original (outbound) shipping charges are non-refundable except where the return is due to our error or a verified shipping-damage/defect claim.",
            "Return shipping is paid by Lecis Auto Glass on approved returns handled according to our Return Policy — we provide a prepaid return label or reimburse the agreed return shipping cost.",
            "Returns that are not authorized, are outside the return window, or arrive not in resalable condition may not qualify for covered return shipping.",
          ]}
        />
      </Section>

      <Section title="Non-Refundable Items">
        <PolicyList
          items={[
            "Items that have been installed, used, or damaged after delivery.",
            "Items returned without a Return Authorization or outside the return window.",
            "Special-order, custom, or clearance items marked as non-returnable.",
            "Items missing original packaging, hardware, or components required for resale.",
          ]}
        />
      </Section>

      <Section title="Order Cancellations">
        <p>
          If you need to cancel an order, contact us as soon as possible at support@lecisautoglass.com. Orders
          that have not yet shipped can usually be cancelled for a full refund. Once an order has shipped, our
          standard Return and Refund Policies apply.
        </p>
      </Section>
    </PolicyLayout>
  );
}
